/** Shared SEO & local business copy (East Tambaram, Chennai) */
export const SITE_NAME = 'PR Builders';
export const LOCALITY = 'East Tambaram';
export const AREA = 'Tambaram';
export const CITY = 'Chennai';
export const STATE = 'Tamil Nadu';
export const COUNTRY = 'India';
export const POSTAL_CODE = '600127';
export const STREET = 'Vengadamangalam';
export const PHONE_E164 = '+918610074336';
export const PHONE_DISPLAY = '+91 8610074336';
export const EMAIL = 'contactus@pr-builders.in';

/** Short link from Google Maps / Search share (opens location in Google Maps) */
export const GOOGLE_MAPS_PLACE_URL = 'https://share.google/6Yi9q0aRbumia7PIQ';

/** Must match your exact Maps pin; update if the marker on Google Maps differs */
export const MAP_LAT = 12.9175;
export const MAP_LNG = 80.127;

/** Zero-API lazy embed (iframe) — q=lat,lng centers the map on the office */
export const GOOGLE_MAPS_EMBED_URL = `https://maps.google.com/maps?q=${MAP_LAT},${MAP_LNG}&z=17&hl=en&ie=UTF8&iwloc=&output=embed`;

export const DEFAULT_TITLE = `${SITE_NAME} | Construction & Home Builders in ${LOCALITY}, ${CITY}`;
export const DEFAULT_DESCRIPTION =
  `${SITE_NAME} is a construction company in ${LOCALITY}, ${CITY}, serving ${AREA}, South Chennai, and wider Tamil Nadu. ` +
  'Residential construction, civil contractors, turnkey homes, renovations, and commercial builds. ' +
  `Trusted builders near ${LOCALITY} with quality delivery. Call ${PHONE_DISPLAY}.`;

export const SEO_KEYWORDS = [
  `${SITE_NAME} ${CITY}`,
  `construction company ${LOCALITY}`,
  `builders ${LOCALITY}`,
  `construction ${AREA}`,
  `home construction ${CITY}`,
  `residential builders ${CITY}`,
  `civil contractors ${CITY}`,
  `building contractors ${LOCALITY}`,
  `turnkey construction ${CITY}`,
  `${STREET} builders ${CITY}`,
  `construction company South ${CITY}`,
].join(', ');

export function getLocalBusinessJsonLd(baseOrigin) {
  const base = baseOrigin.replace(/\/$/, '');
  return {
    '@context': 'https://schema.org',
    '@type': ['HomeAndConstructionBusiness', 'LocalBusiness'],
    name: SITE_NAME,
    image: `${base}/logo192.png`,
    url: `${base}/`,
    telephone: PHONE_E164,
    email: EMAIL,
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress: `${STREET}, ${LOCALITY}`,
      addressLocality: CITY,
      addressRegion: STATE,
      postalCode: POSTAL_CODE,
      addressCountry: 'IN',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: MAP_LAT,
      longitude: MAP_LNG,
    },
    areaServed: [
      { '@type': 'Place', name: LOCALITY },
      { '@type': 'City', name: CITY },
      { '@type': 'AdministrativeArea', name: `${AREA}, ${CITY}` },
    ],
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '09:00',
      closes: '18:00',
    },
  };
}
